module.exports = __webpack_public_path__ + "static/media/desertToadWizardMoving.60de68f8.gif";